import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  alert: {
    padding: 0,
    width: "100%",
    marginBottom: 0,
    [`@media (max-width: ${breakpoints.md}px)`]: {
      position: "relative"
    }
  },
  inside: {
    padding: "16px 32px",
    borderRadius: 0,
    "& .btn-close": {
      padding: "1.5rem 1rem"
    },
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      paddingBottom: "6px"
    }
  }
}));

export default styles;
